import {Component} from 'react';

export default class UnmountHandler extends Component {
  componentWillUnmount() {
    this.props.onLeavePage(this.props.shumaId)
  }
  render() {
    return null
  }
}



